// import external modules
import React, { Component, Suspense, lazy } from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import Spinner from "../components/spinner/spinner";

// import internal(own) modules
import MainLayoutRoutes from "../layouts/routes/mainRoutes";
import FullPageLayout from "../layouts/routes/fullpageRoutes";
import ErrorLayoutRoute from "../layouts/routes/errorRoutes";

// Main Layout
const LazyEcommerceDashboard = lazy(() => import("../views/dashboard/ecommerceDashboard"));

// Role permission
const RoleList = lazy(() => import("../views/users/roles/roleList"))
const RoleCreate = lazy(() => import("../views/users/roles/roleCreate"))
const RoleEdit = lazy(() => import("../views/users/roles/roleEdit"))
const RoleView = lazy(() => import("../views/users/roles/roleView"))
const RoleDelete = lazy(() => import("../views/users/roles/roleDelete"))
const RolePermission = lazy(() => import("../views/users/roles/rolePermission"))
const RolePermissionCreate = lazy(() => import("../views/users/roles/permissionCreate"))

// User
const UserList = lazy(() => import("../views/users/userList"));
const UserCreate = lazy(() => import("../views/users/userCreate"));
const UserEdit = lazy(() => import("../views/users/userEdit"));
const UserView = lazy(() => import("../views/users/userView"));
const UserDelete = lazy(() => import("../views/users/userDelete"));
const SystemSetting = lazy(() => import("../views/settings/systemSetting"));
const SecuritySetting = lazy(() => import("../views/settings/securitySetting"));

// Promotion
const PromotionList = lazy(() => import('../views/promotions/promotionList'))
const PromotionCreate = lazy(() => import('../views/promotions/promotionCreate'))
const PromotionView = lazy(() => import('../views/promotions/promotionView'))
const PromotionEdit = lazy(() => import('../views/promotions/promotionEdit'))
const PromotionDelete = lazy(() => import('../views/promotions/promotionDelete'))

const ProductList = lazy(() => import("../views/products/productList"));
const ProductCreate = lazy(() => import("../views/products/productCreate"));
const ProductEdit = lazy(() => import("../views/products/productEdit"));
const ProductView = lazy(() => import("../views/products/productView"));
const ProductDelete = lazy(() => import("../views/products/productDelete"));

const ScheduleList = lazy(() => import("../views/schedules/ScheduleList"));


// Transections Management

// const CustomerList = lazy(() => import("../views/customers/customerList"));
// const CustomerCreate = lazy(() => import("../views/customers/customerCreate"));
// const CustomerEdit = lazy(() => import("../views/customers/customerEdit"));
// const CustomerView = lazy(() => import("../views/customers/customerView"));
// const CustomerDelete = lazy(() => import("../views/customers/customerDelete"));
// const CustomerTransaction = lazy(() => import("../views/customers/customerTransaction"));

// const PriceCheckView = lazy(() => import("../views/transections/priceChecks/priceCheckView"))
// const PriceCheckList = lazy(() => import("../views/transections/priceChecks/priceCheckList"))
// const PriceCheckDelete = lazy(() => import("../views/transections/priceChecks/priceCheckDelete"))

// const PromotionCheckList = lazy(() => import("../views/transections/promotionChecks/promotionCheckList"))
// const PromotionCheckView = lazy(() => import("../views/transections/promotionChecks/promotionCheckView"))
// const PromotionCheckDelete = lazy(() => import("../views/transections/promotionChecks/promotionCheckDelete"))

// const ShareOfShelvesList = lazy(() => import("../views/transections/shareOfShelves/shareOfShelvesList"))
// const ShareOfShelvesView = lazy(() => import("../views/transections/shareOfShelves/shareOfShelvesView"))
// const ShareOfShelvesDelete = lazy(() => import("../views/transections/shareOfShelves/shareOfShelvesDelete"))

// const OnShelfAvailabilitiesList = lazy(() => import("../views/transections/onShelfAvailabilities/list"))
// const OnShelfAvailabilitiesView = lazy(() => import("../views/transections/onShelfAvailabilities/view"))
// const OnShelfAvailabilitiesDelete = lazy(() => import("../views/transections/onShelfAvailabilities/delete"))

// const StockTakeList = lazy(() => import('../views/transections/stockTakes/stockTakeList'))
// const StockTakeView = lazy(() => import('../views/transections/stockTakes/stockTakeView'))
// const StockTakeDelete = lazy(() => import('../views/transections/stockTakes/stockTakeDelete'))

// const SurveyList = lazy(() => import('../views/transections/surveys/surveyList'))
// const SurveyView = lazy(() => import('../views/transections/surveys/surveyView'))
// const SurveyDelete = lazy(() => import('../views/transections/surveys/surveyDelete'))

// const PosmRequestView = lazy(() => import("../views/transections/posmRequests/posmRequestView"))
// const PosmRequestList = lazy(() => import("../views/transections/posmRequests/posmRequestList"))
// const PosmRequestDelete = lazy(() => import("../views/transections/posmRequests/posmRequestDelete"))

// Customer V2
const CustomerList = lazy(() => import("../views/customers/v2/customerList"));
const CustomerCreate = lazy(() => import("../views/customers/v2/customerCreate"));
const CustomerEdit = lazy(() => import("../views/customers/v2/customerEdit"));
const CustomerView = lazy(() => import("../views/customers/v2/customerView"));
const CustomerDelete = lazy(() => import("../views/customers/v2/customerDelete"));
const CustomerTransaction = lazy(() => import("../views/customers/v2/customerTransaction"));

// Pricecheck V2
const PriceCheckView = lazy(() => import("../views/transections/v2/priceChecks/priceCheckView"))
const PriceCheckList = lazy(() => import("../views/transections/v2/priceChecks/priceCheckList"))
const PriceCheckDelete = lazy(() => import("../views/transections/v2/priceChecks/priceCheckDelete"))

// PromotionCheck V2
const PromotionCheckList = lazy(() => import("../views/transections/v2/promotionChecks/promotionCheckList"))
const PromotionCheckView = lazy(() => import("../views/transections/v2/promotionChecks/promotionCheckView"))
const PromotionCheckDelete = lazy(() => import("../views/transections/v2/promotionChecks/promotionCheckDelete"))

// ShareOfShelve V2
const ShareOfShelvesList = lazy(() => import("../views/transections/v2/shareOfShelves/shareOfShelvesList"))
const ShareOfShelvesView = lazy(() => import("../views/transections/v2/shareOfShelves/shareOfShelvesView"))
const ShareOfShelvesDelete = lazy(() => import("../views/transections/v2/shareOfShelves/shareOfShelvesDelete"))

// Onshelve V2
const OnShelfAvailabilitiesList = lazy(() => import("../views/transections/v2/onShelfAvailabilities/list"))
const OnShelfAvailabilitiesView = lazy(() => import("../views/transections/v2/onShelfAvailabilities/view"))
const OnShelfAvailabilitiesDelete = lazy(() => import("../views/transections/v2/onShelfAvailabilities/delete"))

// Stocktake V2
const StockTakeList = lazy(() => import('../views/transections/v2/stockTakes/stockTakeList'))
const StockTakeView = lazy(() => import('../views/transections/v2/stockTakes/stockTakeView'))
const StockTakeDelete = lazy(() => import('../views/transections/v2/stockTakes/stockTakeDelete'))

// Surveys V2
const SurveyList = lazy(() => import('../views/transections/v2/surveys/surveyList'))
const SurveyView = lazy(() => import('../views/transections/v2/surveys/surveyView'))
const SurveyDelete = lazy(() => import('../views/transections/v2/surveys/surveyDelete'))
// Posm V2
const PosmRequestView = lazy(() => import("../views/transections/v2/posmRequests/posmRequestView"))
const PosmRequestList = lazy(() => import("../views/transections/v2/posmRequests/posmRequestList"))
const PosmRequestDelete = lazy(() => import("../views/transections/v2/posmRequests/posmRequestDelete"))

// Question
const QuestionList = lazy(() => import('../views/question/questionList'))
const QuestionCreate = lazy(() => import('../views/question/questionCreate'))
const QuestionView = lazy(() => import('../views/question/questionView'))
const QuestionEdit = lazy(() => import('../views/question/questionEdit'))
const QuestionDelete = lazy(() => import('../views/question/questionDelete'))

// Questionaire
const QuestionaireList = lazy(() => import('../views/questionaire/questionaireList'))
const QuestionaireCreate = lazy(() => import('../views/questionaire/questionaireCreate'))
const QuestionaireView = lazy(() => import('../views/questionaire/questionaireView'))
const QuestionaireEdit = lazy(() => import('../views/questionaire/questionaireEdit'))
const QuestionaireDelete = lazy(() => import('../views/questionaire/questionaireDelete'))

const MobileSyncFrequencySetting = lazy(() => import('../views/mobileSync/frequencySetting'))

// Reports Transaction
// const ReportOnShelfAvailable = lazy(() => import('../views/reports/transactions/onShelfAvailable'))
// const ReportPriceCheck = lazy(() => import('../views/reports/transactions/priceCheck'))
// const ReportPromotionCheck = lazy(() => import('../views/reports/transactions/promotionCheck'))
// const ReportShareOfShelve = lazy(() => import('../views/reports/transactions/shareOfShelve'))
// const ReportStockTake = lazy(() => import('../views/reports/transactions/stockTake'))
// const ReportSurvey = lazy(() => import('../views/reports/transactions/survey'))
// const ReportPosmRequest = lazy(() => import('../views/reports/transactions/posmRequest'))
// Report Transaction V2
const ReportOnShelfAvailable = lazy(() => import('../views/reports/transactions/v2/onShelfAvailable'))
const ReportPriceCheck = lazy(() => import('../views/reports/transactions/v2/priceCheck'))
const ReportPromotionCheck = lazy(() => import('../views/reports/transactions/v2/promotionCheck'))
const ReportShareOfShelve = lazy(() => import('../views/reports/transactions/v2/shareOfShelve'))
const ReportStockTake = lazy(() => import('../views/reports/transactions/v2/stockTake'))
const ReportSurvey = lazy(() => import('../views/reports/transactions/v2/survey'))
const ReportPosmRequest = lazy(() => import('../views/reports/transactions/v2/posmRequest'))

// Full Layout
const LazyLogin = lazy(() => import("../views/pages/login"));
const ChangePassword = lazy(() => import("../views/authentication/changePassword"))

// Error Pages
const LazyErrorPage = lazy(() => import("../views/pages/error"));

const ProvinceEdit = lazy(() => import('../views/settings/province/provinceEdit'))
const ProvinceCreate = lazy(() => import('../views/settings/province/provinceCreate.js'))
const ProvinceList = lazy(() => import('../views/settings/province/provinceList'))
const ProvinceDelete = lazy(() => import('../views/settings/province/provinceDelete'))

const RegionEdit = lazy(() => import('../views/settings/region/regionEdit'))
const RegionCreate = lazy(() => import('../views/settings/region/regionCreate.js'))
const RegionList = lazy(() => import('../views/settings/region/regionList'))
const RegionDelete = lazy(() => import('../views/settings/region/regionDelete'))

const CountryEdit = lazy(() => import('../views/settings/country/countryEdit'))
const CountryCreate = lazy(() => import('../views/settings/country/countryCreate.js'))
const CountryList = lazy(() => import('../views/settings/country/countryList'))
const CountryDelete = lazy(() => import('../views/settings/country/countryDelete'))

const DistributorEdit = lazy(() => import('../views/settings/distributor/distributorEdit'))
const DistributorCreate = lazy(() => import('../views/settings/distributor/distributorCreate.js'))
const DistributorList = lazy(() => import('../views/settings/distributor/distributorList'))
const DistributorDelete = lazy(() => import('../views/settings/distributor/distributorDelete'))

const CategoryEdit = lazy(() => import('../views/category/categoryEdit'))
const CategoryCreate = lazy(() => import('../views/category/categoryCreate'))
const CategoryList = lazy(() => import('../views/category/categoryList'))

const MaterialCreate = lazy(() => import('../views/material/materialCreate'))
const MaterialList = lazy(() => import('../views/material/materialList'))
const MaterialEdit = lazy(() => import('../views/material/materialEdit'))

const SubsidiaryList = lazy(() => import('../views/subsidiary/subsidiaryList'))
const SubsidiaryCreate = lazy(() => import('../views/subsidiary/subsidiaryCreate'))
const SubsidiaryEdit = lazy(() => import('../views/subsidiary/subsidiaryEdit'))
const SubsidiaryView = lazy(() => import('../views/subsidiary/subsidiaryView'))
const SubsidiaryDelete = lazy(() => import('../views/subsidiary/subsidiaryDelete'))

const PrivacyPolicyView = lazy(() => import("../views/privacyPolicy/privacyPolicyView"))

const DistrictList = lazy(() => import('../views/settings/district/DistrictList'))
const DistrictCreate = lazy(() => import('../views/settings/district/DistrictCreate'))
const DistrictEdit = lazy(() => import('../views/settings/district/DistrictEdit'))
const DistrictDelete = lazy(() => import('../views/settings/district/DistrictDelete'))

const SubDistrictList = lazy(() => import('../views/settings/sub-district/SubDistrictList'))
const SubDistrictCreate = lazy(() => import('../views/settings/sub-district/SubDistrictCreate'))
const SubDistrictEdit = lazy(() => import('../views/settings/sub-district/SubDistrictEdit'))
const SubDistrictDelete = lazy(() => import('../views/settings/sub-district/SubDistrictDelete'))

const ClassificationList = lazy(() => import('../views/settings/classification/ClassificationList'))
const ClassificationCreate = lazy(() => import('../views/settings/classification/ClassificationCreate'))
const ClassificationEdit = lazy(() => import('../views/settings/classification/ClassificationEdit'))
const ClassificationDelete = lazy(() => import('../views/settings/classification/ClassificationDelete'))

const TypeList = lazy(() => import('../views/settings/type/TypeList'))
const TypeCreate = lazy(() => import('../views/settings/type/TypeCreate'))
const TypeEdit = lazy(() => import('../views/settings/type/TypeEdit'))
const TypeDelete = lazy(() => import('../views/settings/type/TypeDelete'))

const TargetTypeList = lazy(() => import('../views/settings/target-type/TargetTypeList'))
const TargetTypeCreate = lazy(() => import('../views/settings/target-type/TargetTypeCreate'))
const TargetTypeEdit = lazy(() => import('../views/settings/target-type/TargetTypeEdit'))
const TargetTypeDelete = lazy(() => import('../views/settings/target-type/TargetTypeDelete'))

const ReasonNotAppointList = lazy(() => import('../views/settings/reason-not-appoint/ReasonNotAppointList'))
const ReasonNotAppointCreate = lazy(() => import('../views/settings/reason-not-appoint/ReasonNotAppointCreate'))
const ReasonNotAppointEdit = lazy(() => import('../views/settings/reason-not-appoint/ReasonNotAppointEdit'))
const ReasonNotAppointDelete = lazy(() => import('../views/settings/reason-not-appoint/ReasonNotAppointDelete'))

const SnapToRoadList = lazy(() => import('../views/snapToRoad/snapToRoadList'))
const DistanceReportList = lazy(() => import('../views/distanceReport/distanceReportList'))

class Router extends Component {
   render() {
      return (
         // Set the directory path if you are deplying in sub-folder
         <BrowserRouter basename="/">
            <Switch>
               {/* Dashboard Views */}
               <MainLayoutRoutes
                  exact
                  path="/"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <LazyEcommerceDashboard {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/users"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <UserList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/roles"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <RoleList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/roles/create"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <RoleCreate {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/roles/edit/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <RoleEdit {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/roles/view/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <RoleView {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/roles/delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <RoleDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/rolePermission"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <RolePermission {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/rolePermission/create/permission"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <RolePermissionCreate {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  path="/users/create"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <UserCreate {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  path="/users/edit/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <UserEdit {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  path="/users/view/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <UserView {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  path="/users/delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <UserDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/customers"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <CustomerList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/customers/create"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <CustomerCreate {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  path="/customers/edit/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <CustomerEdit {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  path="/customers/view/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <CustomerView {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  path="/customers/history/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <CustomerTransaction {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  path="/customers/delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <CustomerDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/products"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ProductList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/products/create"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ProductCreate {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/products/edit/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ProductEdit {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/products/view/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ProductView {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/products/delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ProductDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/security"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <SecuritySetting {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/system"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <SystemSetting {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/promotions"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <PromotionList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/promotions/create"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <PromotionCreate {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/promotions/view/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <PromotionView {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/promotions/edit/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <PromotionEdit {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/promotions/delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <PromotionDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/schedules"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ScheduleList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/pricechecks"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <PriceCheckList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/pricechecks/view/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <PriceCheckView {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/pricechecks/delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <PriceCheckDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/promotionchecks"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <PromotionCheckList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/promotionchecks/view/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <PromotionCheckView {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/promotionchecks/delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <PromotionCheckDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/shareofshelves"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ShareOfShelvesList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/shareofshelves/view/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ShareOfShelvesView {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/shareofshelves/delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ShareOfShelvesDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/onShelfAvailabilities"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <OnShelfAvailabilitiesList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/onShelfAvailabilities/view/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <OnShelfAvailabilitiesView {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/onShelfAvailabilities/delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <OnShelfAvailabilitiesDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/stocktakes"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <StockTakeList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/stocktakes/view/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <StockTakeView {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/stocktakes/delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <StockTakeDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/questions"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <QuestionList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/questions/create"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <QuestionCreate {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/questions/view/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <QuestionView {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/questions/edit/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <QuestionEdit {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/questions/delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <QuestionDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/questionaires"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <QuestionaireList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/questionaires/create"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <QuestionaireCreate {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/questionaires/view/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <QuestionaireView {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/questionaires/edit/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <QuestionaireEdit {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/questionaires/delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <QuestionaireDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/surveys"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <SurveyList {...matchprops} />
                     </Suspense>
                  )}
               />

               {/* <MainLayoutRoutes
                  exact
                  path="/surveys/view/:survey_id/questionaire/:questionaire_id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <SurveyView {...matchprops} />
                     </Suspense>
                  )}
               /> */}

               <MainLayoutRoutes
                  exact
                  path="/surveys/view/:survey_id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <SurveyView {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/surveys/delete/:survey_id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <SurveyDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/posmrequests"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <PosmRequestList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/posmrequests/view/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <PosmRequestView {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/posmrequests/delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <PosmRequestDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/mobileSyncFrequencySettings"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <MobileSyncFrequencySetting {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/reports/transactions/onShelfAvailable"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ReportOnShelfAvailable {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/reports/transactions/priceCheck"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ReportPriceCheck {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/reports/transactions/promotionCheck"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ReportPromotionCheck {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/reports/transactions/shareOfShelve"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ReportShareOfShelve {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/reports/transactions/stockTake"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ReportStockTake {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/reports/transactions/survey"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ReportSurvey {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/reports/transactions/posmRequest"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ReportPosmRequest {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/provinces"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ProvinceList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/provinces/create"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ProvinceCreate {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/provinces/delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ProvinceDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/provinces/edit/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ProvinceEdit {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/districts"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <DistrictList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/districts/create"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <DistrictCreate {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/districts/delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <DistrictDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/districts/edit/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <DistrictEdit {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/sub-districts"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <SubDistrictList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/sub-districts/create"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <SubDistrictCreate {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/sub-districts/delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <SubDistrictDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/sub-districts/edit/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <SubDistrictEdit {...matchprops} />
                     </Suspense>
                  )}
               />
               
               <MainLayoutRoutes
                  exact
                  path="/setting/classifications"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ClassificationList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/classifications/create"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ClassificationCreate {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/classifications/delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ClassificationDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/classifications/edit/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ClassificationEdit {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/types"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <TypeList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/types/create"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <TypeCreate {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/types/delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <TypeDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/types/edit/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <TypeEdit {...matchprops} />
                     </Suspense>
                  )}
               />

               {/* Target Type */}
               <MainLayoutRoutes
                  exact
                  path="/setting/target-types"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <TargetTypeList {...matchprops} />
                     </Suspense>
                  )}
               />
               <MainLayoutRoutes
                  exact
                  path="/setting/target-type/create"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <TargetTypeCreate {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/target-type/delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <TargetTypeDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/target-type/edit/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <TargetTypeEdit {...matchprops} />
                     </Suspense>
                  )}
               />

               {/* Regions */}
               <MainLayoutRoutes
                  exact
                  path="/setting/regions"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <RegionList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/regions/create"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <RegionCreate {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/regions/delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <RegionDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/regions/edit/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <RegionEdit {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/countries"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <CountryList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/countries/create"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <CountryCreate {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/countries/delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <CountryDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/countries/edit/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <CountryEdit {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/distributors"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <DistributorList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/distributors/create"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <DistributorCreate {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/distributors/delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <DistributorDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/distributors/edit/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <DistributorEdit {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/categories"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <CategoryList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/categories/create"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <CategoryCreate {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/categories/edit/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <CategoryEdit {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/materials"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <MaterialList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/materials/create/"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <MaterialCreate {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/materials/edit/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <MaterialEdit {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/subsidiaries"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <SubsidiaryList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/subsidiaries/create"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <SubsidiaryCreate {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/subsidiaries/edit/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <SubsidiaryEdit {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/subsidiaries/view/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <SubsidiaryView {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/subsidiaries/Delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <SubsidiaryDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/reason-not-appoint"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ReasonNotAppointList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/reason-not-appoint/create"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ReasonNotAppointCreate {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/reason-not-appoint/delete/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ReasonNotAppointDelete {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/setting/reason-not-appoint/edit/:id"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ReasonNotAppointEdit {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/snaptoroad"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <SnapToRoadList {...matchprops} />
                     </Suspense>
                  )}
               />

               <MainLayoutRoutes
                  exact
                  path="/distancereport"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <DistanceReportList {...matchprops} />
                     </Suspense>
                  )}
               />
               
               <FullPageLayout
                  exact
                  path="/login"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <LazyLogin {...matchprops} />
                     </Suspense>
                  )}
               />

               <FullPageLayout
                  exact
                  path="/changePassword"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <ChangePassword {...matchprops} />
                     </Suspense>
                  )}
               />

               <FullPageLayout
                  exact
                  path="/privacy-policy"
                     render={matchprops => (
                        <Suspense fallback={<Spinner />}>
                           <PrivacyPolicyView {...matchprops} />
                        </Suspense>
                     )}
               />

               {/* <ErrorLayoutRoute
                  exact
                  path="/pages/error"
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <LazyErrorPage {...matchprops} />
                     </Suspense>
                  )}
               />

               <ErrorLayoutRoute
                  render={matchprops => (
                     <Suspense fallback={<Spinner />}>
                        <LazyErrorPage {...matchprops} />
                     </Suspense>
                  )}
               /> */}
            </Switch>
         </BrowserRouter>
      );
   }
}

export default Router;
